<template>
  <div :class="classes" v-loading="loading">
     <pt-page-title title="往期视频" :isSearch="true" @search="search" :searchKey="keyword" @emptySearch="emptySearch">
      <el-button slot="before-left" type="primary" @click="toCreate">新建视频</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabel" v-model="params" isQueryRouter @Filter="Filter" ref="filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
     <pt-previous-video-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" ref="table" :paramsData="paramsData">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="goDelete(scope.row)">删除</el-button>
          <el-button type="text" @click="preview(scope.row)">预览</el-button>
          <el-button type="text" @click="toSubmit(scope.row)" v-if="scope.row.status==='SCRIPT'">审核</el-button>
        </template>
      </el-table-column>
    </pt-previous-video-table>
    <review-poster-mobile :isVideo="true" :showDialog="showDialog" @closeDialog="showDialog = false" :detail="currentData"></review-poster-mobile>
  </div>
</template>

<script>
import reviewPosterMobile from 'cps/tool-operation/review-poster-mobile'
import ptPreviousVideoTable from './pt-previous-video-table/withData'
import {
  emptyObject
} from '@/utils/lifebankUtils'
import { videoFilterLabel, videoTableLabels } from '../famous-doctor-hall'
// 组件class前缀
const prefixCls = 'pt-previous-video'

export default {
  name: 'pt-previous-video',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptPreviousVideoTable,
    reviewPosterMobile
  },
  data () {
    return {
      keyword: '',
      params: {},
      paramsData: {},
      filterLabel: videoFilterLabel,
      tableLabels: videoTableLabels,
      isFromRouter: false,
      currentData: {},
      showDialog: false,
      loading: false
    }
  },
  methods: {
    search (val) {
      this.keyword = val
      this.isFromRouter = false
      emptyObject(this.params)
      this.paramsData = {
        keyword: val
      }
    },
    emptySearch () {
      this.keyword = null
      this.$delete(this.paramsData, 'keyword')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'crecordingTime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData = {
        ...this.params
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    },
    toCreate () {
      this.$router.push('/previous-video/previous-video-form/false/0')
    },
    goEdit (val) {
      this.$router.push('/previous-video/previous-video-form/true/' + val.id)
    },
    goDetail (val) {
      this.$router.push('/previous-video-detail/' + val.id)
    },
    goDelete (row) {
      this.$confirm(`确定要删除视频：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deteleVideo', row.id).then(data => {
          this.$refs.table.load()
          this.$message.success('删除成功！')
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    toSubmit (row) {
      this.$confirm(`确定要提交审核视频：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let data = {
          id: row.id,
          status: 'SUBMITTED'// 提交审核
        }
        this.$store.dispatch('videoOperation', data).then(data => {
          this.$refs.table.load()
          this.$message.success('提交成功！')
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      })
    },
    // 预览
    preview (data) {
      this.showDialog = true
      this.currentData = data
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
